import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting, cvLinks } from "../../portfolio";
import { Fade } from "react-awesome-reveal";
import emoji from "react-easy-emoji";
import manOnTableImg from "../../assets/images/ghibli3.jpg";
export default function Greeting() {
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text">
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p className="greeting-text-p subTitle">{greeting.subTitle}</p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="/#contact" />
                <Button
                  text="⬇ my resume "
                  newTab={true}
                  href={cvLinks.cvLink1}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <img
              className="greeting-image"
              alt="man sitting on table"
              src={manOnTableImg}
            ></img>
          </div>
        </div>
      </div>
    </Fade>
  );
}
